import { flowAsync } from '@gcc/nodash';
import { get, map, set } from 'lodash/fp';
import { copyConfiguration } from '../../api/designBuilder';

export default cartingOptions => flowAsync(
  get('productOnlyItems'),
  map(async item => set(
    'itemProduct.configurationGuid',
    await copyConfiguration(
      get('itemProduct.configurationGuid')(item),
      get('label')(item),
    ),
    item,
  )),
  async promises => Promise.all(promises),
  items => ({
    ...cartingOptions,
    productOnlyItems: items,
  }),
)(cartingOptions);
